import React, { useEffect } from "react";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { isDisableSubmit } from "../../../utils";
import { validationFLFIotPartnerInput } from "../../../utils/validateInput";
import { useState } from "react";

const initialValue = {
  id: "",
  partnerName: "",
  devices: [],
};

function FLFIotPartnerForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFIotPartnerForm = (fieldValues = values) => {
    let temp = validationFLFIotPartnerInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFIotPartnerForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateFLFIotPartnerForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="partnerName"
        value={values.partnerName}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.partnerName}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFIotPartnerForm;
